import { render } from "./MainMenu.vue?vue&type=template&id=3b7862d8&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "../assets/index.rem-MainMenu.css?vue&type=style&index=0&id=3b7862d8&scoped=true&lang=css"
import "./MainMenu.vue?vue&type=style&index=1&id=3b7862d8&scoped=true&lang=css"

import exportComponent from "E:\\virtual-weather-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7862d8"]])

export default __exports__